// extracted by mini-css-extract-plugin
export var breadcrumb = "_1c-0";
export var breadcrumbArrow = "_1c-1";